// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../../services/apiService/apiService';

const apiToastrMessages = {
  GET_ZONE_DETAILS_FAILED: 'Failure in fetching zone details: ',
  GET_ZONE_DETAILS_EXCEPTION: 'Exception in fetching zone details: ',
  UPDATE_ZONE_DETAILS_FAILED: 'Failure in updating zone details: ',
  UPDATE_ZONE_DETAILS_EXCEPTION: 'Exception in updating zone details: ',
  UPDATE_ZONE_DETAILS_SUCCESSFUL: 'Zone updated successfully: ',
  EDIT_ZONE_PRESENCE_FAILED: 'Zone presence could not be done: ',
  EDIT_ZONE_PRESENCE_EXCEPTION:
    'Exception occurred while editing zone presence: '
};

export const zoneActions = {
  UPDATE_ZONE_DETAILS: 'UPDATE_ZONE_DETAILS'
};

export const updateZoneDetailsAction = (obj: Object) => ({
  type: zoneActions.UPDATE_ZONE_DETAILS,
  payload: obj
});

export const getZoneDetails = id => (dispatch: Function) => {
  dispatch(
    updateZoneDetailsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log('Getting all Zone Types');

  const requestObj = {
    baseUrl: 'zoomWmsBaseUrl',
    apiEndPoint: 'getActiveZonebyType',
    method: 'GET',
    replaceParamsArr: [{ key: 'zoneTypeId', val: id }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          updateZoneDetailsAction({
            isLoading: false,
            isLoaded: true,
            data: res.payload
          })
        );
        //  eslint-disable-next-line
        console.log('Zone details api call successful', res.payload);
      } else if (res.status === 'FAILURE') {
        dispatch(
          updateZoneDetailsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(`${apiToastrMessages.GET_ZONE_DETAILS_FAILED}, res= `, res);
      dispatch(
        updateZoneDetailsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error('Failure', res.errorMessage, {
        timeout: 3000
      });
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(apiToastrMessages.GET_ZONE_DETAILS_EXCEPTION, res);
      dispatch(
        updateZoneDetailsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error(
        'Exception',
        apiToastrMessages.GET_ZONE_DETAILS_EXCEPTION,
        res.errorMessage,
        {
          timeOut: 3000
        }
      );
    }
  };
  makeApiCall(requestObj);
};

export const updateZoneDetails = (zoneDetails, successCallback: Function) => (
  dispatch: Function
) => {
  dispatch(
    updateZoneDetailsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log('Updating zone details');

  const requestObj = {
    baseUrl: 'zoomWmsBaseUrl',
    apiEndPoint: 'updateZoneDetails',
    method: 'POST',
    data: zoneDetails,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          updateZoneDetailsAction({
            isLoading: false,
            isLoaded: true,
            data: res.payload
          })
        );
        //  eslint-disable-next-line
        console.log('Zone details update api call successful', res.payload);

        toastr.success('Success', apiToastrMessages.UP, {
          timeout: 3000
        });
        if (successCallback) {
          successCallback();
        }
      } else if (res.status === 'FAILURE') {
        dispatch(
          updateZoneDetailsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(
        `${apiToastrMessages.UPDATE_ZONE_DETAILS_FAILED}, res= `,
        res
      );
      dispatch(
        updateZoneDetailsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error('Failure', res.errorMessage, {
        timeout: 3000
      });
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(apiToastrMessages.UPDATE_ZONE_DETAILS_EXCEPTION, res);
      dispatch(
        updateZoneDetailsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error(
        'Exception',
        apiToastrMessages.UPDATE_ZONE_DETAILS_EXCEPTION,
        res.errorMessage,
        {
          timeOut: 3000
        }
      );
    }
  };
  makeApiCall(requestObj);
};

export const editZonePresence = zonePresenceObject => (dispatch: Function) => {
  dispatch(
    updateZoneDetailsAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );
  // eslint-disable-next-line no-console
  console.log('Getting all Zone Types');

  const requestObj = {
    baseUrl: 'zoomWmsBaseUrl',
    apiEndPoint: 'editZonePresence',
    pathVariables: [
      {
        key: '#zoneTypeId',
        val: zonePresenceObject.zoneTypeId
      }
    ],
    replaceParamsArr: [{ key: 'present', val: zonePresenceObject.present }],
    method: 'PUT',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          updateZoneDetailsAction({
            isLoading: false,
            isLoaded: true,
            data: res.payload
          })
        );
        //  eslint-disable-next-line
        console.log('Updating Zone Presence successfull', res.payload);
      } else if (res.status === 'FAILURE') {
        dispatch(
          updateZoneDetailsAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(`${apiToastrMessages.EDIT_ZONE_PRESENCE_FAILED}, res= `, res);
      dispatch(
        updateZoneDetailsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error('Failure', res.errorMessage, {
        timeout: 3000
      });
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(apiToastrMessages.EDIT_ZONE_PRESENCE_EXCEPTION, res);
      dispatch(
        updateZoneDetailsAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
      toastr.error(
        'Exception',
        apiToastrMessages.EDIT_ZONE_PRESENCE_EXCEPTION,
        res.errorMessage,
        {
          timeOut: 3000
        }
      );
    }
  };
  makeApiCall(requestObj);
};
